import React, { FC, PropsWithChildren } from "react";

import log from "loglevel";
import { Navigate, Route, Routes as ReactRoutes, useRoutes } from "react-router-dom";

import { AboutPage, ConversationsPage, WaitingForBroker } from "@/components/features";

import ErrorPage from "./components/pages/ErrorPage/ErrorPage";
import { AppRoute, UserState } from "./shared/domain";
import { useAuth, useRouterHook } from "./shared/hooks";
import { useRouteCollection } from "./shared/hooks/useRouteCollection";

const ErrorRoutes = () => {
    return (
        <ReactRoutes>
            <Route path={AppRoute.Root} element={<ErrorPage />} />
            <Route path="*" element={<Navigate to={AppRoute.Root} replace />} />
        </ReactRoutes>
    );
};

const PendingRoutes = () => {
    return (
        <ReactRoutes>
            <Route path={AppRoute.Root} element={<WaitingForBroker />} />
            <Route path={AppRoute.Settings} element={<AboutPage />} />
            <Route path={AppRoute.Error} element={<ErrorPage />} />
            <Route path={AppRoute.Conversations} element={<ConversationsPage />} />
            <Route path="*" element={<Navigate to={AppRoute.Root} replace />} />
        </ReactRoutes>
    );
};

export const DebugRouter: FC<PropsWithChildren> = ({ children }) => {
    const { pathname, searchRaw, state } = useRouterHook();
    if (process.env.NODE_ENV === "development") {
        log.debug(`Route: ${pathname}${searchRaw}, State: ${JSON.stringify(state)}`);
    }
    return <>{children}</>;
};

const AccessRoutes = () => {
    const { routeCollection } = useRouteCollection();

    const routeList = useRoutes(routeCollection);

    return <DebugRouter>{routeList}</DebugRouter>;
};

export const Routes: FC = () => {
    const { userState } = useAuth();
    if (userState === UserState.UNKNOWN) {
        return <ErrorRoutes />;
    }
    if (userState === UserState.PENDING) {
        return <PendingRoutes />;
    }
    if (userState === UserState.ACCESS) {
        return <AccessRoutes />;
    }

    return null;
};
